import Quill from 'quill';
import { Delta, Op } from 'quill/core';

export function deltaToHtml(inputDelta: any) {
  const tempCont = document.createElement('div');
  const quill = new Quill(tempCont);
  quill.setContents(JSON.parse(inputDelta));
  return tempCont.getElementsByClassName('ql-editor')[0].innerHTML;
}

export function isDeltaNotEmpty(delta: string): boolean {
  const ops = JSON.parse(delta) as Op[];

  if (!Array.isArray(ops)) return false;

  if (!ops || ops.length === 0) return false;

  if ((ops.length === 1 && ops[0].insert === '') || ops[0].insert === '\n') {
    return false;
  }

  return true;
}

function removeKeysFromObject(
  obj: Record<string, any>,
  keysToRemove: string[]
) {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !keysToRemove.includes(key))
  );
}

export function cleanDelta(delta: Delta): Delta {
  const cleanedOps = delta.ops.map((op) => {
    if (op.insert === '\n') {
      return { insert: '\n' };
    }
    if (op?.attributes) {
      // eslint-disable-next-line no-param-reassign
      op.attributes = removeKeysFromObject(op.attributes, [
        'color',
        'background',
      ]);
    }
    return op;
  });
  // eslint-disable-next-line no-param-reassign
  delta.ops = cleanedOps;
  return delta;
}
